import * as React from 'react';

import { cn } from '../../lib/utils';

/**
 * Loading placeholder — the handoff's section 05.
 *
 * Skeletons, not spinners, for content, and give the block the dimensions of
 * the thing it stands in for: a skeleton that is the wrong size moves the
 * layout when the data lands, which is worse than showing nothing.
 *
 * The 200ms reveal delay is in the animation rather than in a timer, so a
 * render that resolves quickly never paints a loading state at all and no
 * caller has to remember to debounce one.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-skeleton rounded-md bg-placeholder', className)}
      {...props}
    />
  );
}

export { Skeleton };
